export default __webpack_public_path__ + "static/media/blue-triangle-down.1892b4ba.svg";